// API配置 - 使用相对路径，通过代理访问后端
export const API_BASE_URL = '';

// 构建完整的API URL（使用相对路径）
export const buildApiUrl = (endpoint: string): string => {
  return endpoint.startsWith('/') ? endpoint : `/${endpoint}`;
};

// 获取用户活动日历数据
export async function getActivityCalendar(start: string, end: string) {
  const url = buildApiUrl(`/api/me/activity_calendar?start=${start}&end=${end}`);
  const resp = await fetch(url, {
    credentials: 'include', // 携带cookie
  });
  if (!resp.ok) {
    throw new Error('获取活动日历数据失败');
  }
  return resp.json();
} 